/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The low value in each range is included. The high value in each range is excluded.
 */
export const MonthlyVolumeRange = {
  Under10k: "under-10k",
  Tenk50k: "10k-50k",
  Fiftyk100k: "50k-100k",
  OneHundredk250k: "100k-250k",
  TwoHundredAndFiftyk500k: "250k-500k",
  FiveHundredk1m: "500k-1m",
  Onem5m: "1m-5m",
  Over5m: "over-5m",
} as const;
/**
 * The low value in each range is included. The high value in each range is excluded.
 */
export type MonthlyVolumeRange = ClosedEnum<typeof MonthlyVolumeRange>;

/** @internal */
export const MonthlyVolumeRange$inboundSchema: z.ZodNativeEnum<
  typeof MonthlyVolumeRange
> = z.nativeEnum(MonthlyVolumeRange);
/** @internal */
export const MonthlyVolumeRange$outboundSchema: z.ZodNativeEnum<
  typeof MonthlyVolumeRange
> = MonthlyVolumeRange$inboundSchema;
